import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './vuex'
import './registerServiceWorker'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueObserveVisibility from 'vue-observe-visibility'
import VueGallery from 'vue-gallery'

Vue.component('vue-gallery', VueGallery)

Vue.use(ElementUI, { locale })
Vue.use(VueReCaptcha, {
  siteKey: '6Leh7JYUAAAAAD6i_RLPZWWJHB4TrUPZF6L1Hgx_',
  loaderOptions: {
    autoHideBadge: true
  }
})
Vue.use(VueObserveVisibility)

// IMPORTANT!!! Change before build
const APP_VERSION = 'AMX-Alpha-1.0.1'
Vue.config.productionTip = false
Vue.config.devtools = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.appVersion = APP_VERSION
document.getElementById('app-version').innerHTML = APP_VERSION
